<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <!-- Accordion -->        
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <h3 class="g-color-main">Frames</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-color-primary--hover g-font-size-20--md g-font-size-17 g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17 " v-html="group.items"></span> 
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    data () {
    return {
        collapseStatus: false,
        groups: [
            {
                "name": "Are frames available?",
                "open": false,
                "items": "Check out the <a href='Frames'>Frames Page</a> where you can view the catalog from FGX International, and order a Frame Collection and Frame Replacement."
            },
             {
                "name": "Can I order more than one frame collection?",
                "open": false,
                "items": "You are limited one frame collection per account. Extra Frame Collections may be rented through the Equipment/Hardware Rentals on the Resources Page "
            },
            {
                "name": "Can I only order the frames in the Collection I received?",
                "open": false,
                "items": "No, you are able to order all frame color options available on the Order page."
            },
            {
                "name": "Can I pick the frames in the Collection?",
                "open": false,
                "items": "Unfortunately, you are not able to select the frames in your Collection. You will be provided with a sample of all styles offered to use as trial frames (for your frame board). However, you are able to order all frame color options on the Order page."
            },
            {
                "name": "Can I request all frames for my Collection?",
                "open": false,
                "items": "No, unfortunately, there is not an option to order all frames."
            },
            {
                "name": "If I order the EVF Frame Collection, can I still use my own frames?",
                "open": false,
                "items": "Absolutely. You are always welcome to offer patients a frame from your own inventory and place orders as Frame-to-Come."
            },
            {
                "name": "If the frame is low stock do I use the one from my Collection?",
                "open": false,
                "items": "No, if the frame is low stock you may continue to place orders, and if it becomes out of stock, similar options will be provided on the Order page. Please do not use frames from your Collection for frame-to-come orders as this negatively affects inventory and replacement frame ordering."
            },
            {
                "name": "What does it mean when a frame is low stock/out of stock?",
                "open": false,
                "items": "A frame is indicated as low stock when a limited quantity for ordering is available. We suggest that if a patient selects a frame that you know to be of low stock, that you ask the patient to select another frame as a back-up option. A frame will be indicated as out of stock when it is no longer able to be ordered. Similar frame options will be provided for you to select when placing an order. A frame that is out of stock is still part of the Collection and is in process of being reordered. All frames will remain in the Collection unless specifically discontinued."
            },
            {
                "name": "Can I order another Frame Collection?",
                "open": false,
                "items": "Unfortunately, the program offers one Frame Collection per account. If you are trying to order a Collection for trial at another location, we recommend you set up a second account for that location. There is no option to purchase additional Frame Collections, however they may be rented from the Resources Page (subject to availability)."
            },
            {
                "name": "How often do you plan to refresh the Frame Collection?",
                "open": false,
                "items": "We have established a Collection to remain in-tact over a 2-3 year period. Should a frame become discontinued, we will make adjustments as necessary."
            },
            {
                "name": "What do I do if a frame breaks?",
                "open": false,
                "items": "If a frame breaks you are asked to select the Order Replacement button on the Frame page to request an individual frame replacement. All frame replacements will be subject to Essilor Vision Foundation approval."
            }
        ]
    }
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        },  
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// Frames.vue?0f34864b